export enum ConditionType {
    COMBINED_CONDITION = "COMBINED_CONDITION",
    ALWAYS_TRUE = "ALWAYS_TRUE",
    DATA_CONDITION = "DATA_CONDITION",
    HTTP_STATUS_CODE_CONDITION = "HTTP_STATUS_CODE_CONDITION"    
}